import { Typography, ConfigProvider, Row } from "antd";
import React, { useState, useEffect } from "react";

import downloadIcon from "../assets/icon/download-icon.png";
import folder from "../assets/icon/folder-open.svg";
import power from "../../assets/icons/power.svg";
import excel from "../../assets/icons/excel.svg";
import word from "../../assets/icons/word.svg";
import mkv from "../../assets/icons/mkv.svg";
import mp4 from "../../assets/icons/mp4.svg";
import pdf from "../../assets/icons/pdf.svg";
import config from "../../config";

const DownloadImage = (props) => {
  const getImageSrc = (url) => {
    const extension = url.split(".").pop().toLowerCase(); // Extract the file extension from the URL
    switch (extension) {
      case "pdf":
        return pdf;
      case "doc":
        return word;
      case "docx":
        return word;
      case "xlsx":
        return excel;
      case "ppt":
        return power;
      case "pptx":
        return power;
      case "rar":
      case "aspx":
      case "mp4":
        return mp4;
      case "mkv":
        return mkv;
      case "zip":
        return folder; // Provide path to the PowerPoint icon
      default:
        return url; // Return the original URL for other file types
    }
  };

  const fileSrc = () => {
    if (props.src.includes("be-staging.smilepass.com") || props.src.includes("api.smilepass.com")) {
      return props.src;
    } else {
      return `${config.apiGateway.URL}${props.src}`;
    }
  };

  return (
    <div
      className="imageFileContainer"
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        flexDirection: "column",
        width: 200,
        height: 130,
      }}
    >
      <a
        href={fileSrc()}
        download
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          flexDirection: "column",
          width: 200,
          height: 130,
          bottom: 5,
        }}
      >
        <img
          width={200}
          height={130}
          style={{ width: 200, height: 130, borderRadius: "8px", border: "1px solid #6B43B5" }}
          alt="file"
          src={getImageSrc(props.src) === props.src ? fileSrc() : getImageSrc(props.src)}
        />
        <div
          className="downloadIconContainer"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: "5",
            width: 30,
            height: 30,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img width={15} height={15} src={downloadIcon} alt="download" />
        </div>
        <div
          style={{
            fontSize: 12,
            color: "#6B43B5",
            marginTop: 5,
            textAlign: "center",
            width: 210,
            wordWrap: "break-word",
            overflowWrap: "break-word",
          }}
        >
          {props.name}
        </div>
      </a>
    </div>
  );
};

const TreatmentPlanFile = (props) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (props.data) {
      setData(props.data);
    }
  }, [props]);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#983cfc",
          controlItemBgHover: "#c293ff",
          colorLink: "#983cfc",
          borderRadius: "4px",
        },
        components: {
          Table: {
            borderRadius: "8px",
            borderColor: "#eee",
          },
        },
      }}
    >
      {data && data.image_files && data.image_files.length > 0 && <Typography style={{ fontWeight: 600, fontSize: "16px" }}>Files</Typography>}
      <br />
      <Row style={{ gap: 10 }}>
        {data && data.image_files && data.image_files.length > 0
          ? data.image_files.map((img) => <DownloadImage key={img.id} src={img.image} name={img.file_name} />)
          : data && data.length > 0
          ? data.map((item) => item.path && <DownloadImage key={item.id} src={item.path} name={item.name} />)
          : null}
      </Row>
    </ConfigProvider>
  );
};

export default TreatmentPlanFile;
